import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from '@/lib/auth';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { NewProjectWizard } from '@/pages/NewProjectWizard';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { PurchasePage } from '@/pages/PurchasePage';
import { PurchaseOverviewPage } from '@/pages/PurchaseOverviewPage';
import { CatalogPage } from '@/pages/CatalogPage';
import { InventoryPage } from '@/pages/InventoryPage';
import { SuppliersPage } from '@/pages/SuppliersPage';
import { TextLibraryPage } from '@/pages/TextLibraryPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session, loading } = useSession();
  if (loading) {
    return <div className="flex h-screen items-center justify-center text-slate-400">Laden...</div>;
  }
  if (!session) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="projecten" element={<ProjectsPage />} />
        <Route path="projecten/nieuw" element={<NewProjectWizard />} />
        <Route path="projecten/:id" element={<ProjectDetailPage />} />
        <Route path="projecten/:id/inkoop" element={<PurchasePage />} />
        <Route path="inkoop" element={<PurchaseOverviewPage />} />
        <Route path="catalogus" element={<CatalogPage />} />
        <Route path="teksten" element={<TextLibraryPage />} />
        <Route path="leveranciers" element={<SuppliersPage />} />
        <Route path="voorraad" element={<InventoryPage />} />
      </Route>
    </Routes>
  );
}
